module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h3', [_vm._v("Backhaul Provider Summary")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.chartSites,
      "thousands": ",",
      "legend": "right",
      "colors": _vm.colours,
      "download": true
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.summary,
      "border": "",
      "stripe": "",
      "show-summary": "",
      "sum-text": "Totals",
      "summary-method": _vm.summaryFormatter
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "provider",
      "label": "Provider"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "siteStatus",
      "label": "Site Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaulType",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaulStatus",
      "label": "B/Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sites",
      "label": "Sites",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entranceFee",
      "label": "Entrance Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rowFee",
      "label": "ROW Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customers",
      "label": "Customers",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customerEntranceFee",
      "label": "Cust. Ent. Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customerRowFee",
      "label": "Cust. ROW Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad982f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/backhaul/BackhaulProviderSummary.vue
// module id = 1314
// module chunks = 0